import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { bllInput } from './input.component';

@NgModule({
  imports: [CommonModule],
  declarations: [bllInput],
  exports: [bllInput],
})
export class BllInputModule {}
